import { UiComponent } from '../../../interfaces/pagebuilder';

export const UiComponentBackground = (props: { component: UiComponent }) => {
  const { component } = props;

  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: component.styling?.backgroundColor,
        opacity: component.styling?.backgroundOpacity || 0,
        transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
      }}
    />
  );
};
